import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
let StoreCurrencyRestServiceConfig: IRestfulConfigMap = {
    storeCurrencyRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            default: {
                method: "get",
                path: "api/stores/:storeId/defaultCurrency",
                testPath: "api/stores/:storeId/defaultCurrency",
                paramDefaults: {
                    "storeId": "@storeId"
                }
            }
        }
    }
}


export { StoreCurrencyRestServiceConfig };